import type { IconData } from '@stacksjs/iconify-core'

export const lock: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 11H8a1 1 0 0 1-1-1V7a5 5 0 0 1 10 0v3a1 1 0 0 1-1 1M9 9h6V7a3 3 0 0 0-6 0Z\" opacity=\".5\"/><rect width=\"16\" height=\"13\" x=\"4\" y=\"9\" fill=\"currentColor\" rx=\"3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default lock
